import tourApi from "@/services/api/tour";

export default {
  methods: {
    getTourText(departure) {
      const title = departure.tour;
      const startDate = departure.start_date;
      const endDate = departure.end_date;
      const start = startDate
        ? this.$options.filters.formatDate(startDate)
        : "-";
      const end = endDate ? this.$options.filters.formatDate(endDate) : "-";
      return `${title} - ${start} - ${end}`;
    },

    sortRows(rows) {
      return rows.sort((a, b) => Date.parse(a.date) - Date.parse(b.date));
    },

    toggleNotes(key) {
      this.$set(this.expandedNotes, key, !this.isNotesExpanded(key));
    },

    isNotesExpanded(key) {
      return Boolean(this.expandedNotes[key]);
    },

    isPastDate(date) {
      if (!date) return false;
      const today = new Date();
      const todayString = today.toISOString().slice(0, 10);
      return date < todayString;
    },

    async loadAvailableDepartures() {
      this.departuresLoading = true;
      try {
        const tourResponse = await tourApi.getTours(false);
        const tours = tourResponse.data.tours;

        const departures = tours
          .reduce((result, tour) => {
            const embeddedDepartures = Array.isArray(tour.departures)
              ? tour.departures
              : [];
            const mapped = embeddedDepartures.map(departure => ({
              id: departure.id,
              start_date: departure.start_date,
              end_date: departure.end_date,
              tour_id: departure.tour_id || tour.id,
              label: this.getTourText({
                tour: tour.title,
                start_date: departure.start_date,
                end_date: departure.end_date
              })
            }));
            return result.concat(mapped);
          }, [])
          .filter(
            departure =>
              this.includePast || !this.isPastDate(departure.start_date)
          )
          .sort((a, b) => Date.parse(a.start_date) - Date.parse(b.start_date))
          .map(departure => ({
            id: departure.id,
            start_date: departure.start_date,
            end_date: departure.end_date,
            tour_id: departure.tour_id,
            label: departure.label
          }));

        this.availableDepartures = departures;
      } catch (error) {
        this.availableDepartures = [];
        if (this.$notify) {
          this.$notify({
            timeout: 2500,
            message: "Unable to load departures.",
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        }
      } finally {
        this.departuresLoading = false;
      }
    },

    applyAddDepartureSearch() {
      const search = (this.addDepartureSearch || "").trim().toLowerCase();
      if (!search) {
        this.addForm.departure_id = null;
        return;
      }
      const exactMatch = this.availableDepartures.find(
        departure => (departure.label || "").toLowerCase() === search
      );
      if (!exactMatch) {
        this.addForm.departure_id = null;
        return;
      }
      this.addForm.departure_id = exactMatch.id;
      if (!this.addRows.length) {
        this.addRows = [this.newAddRow(exactMatch.start_date)];
      } else if (!this.addRows[0].date) {
        this.addRows[0].date = exactMatch.start_date;
      }
      this.addDepartureSearch = exactMatch.label;
    },

    addAddRow(date = "") {
      this.addRows.push(this.newAddRow(date));
    },

    removeAddRow(index) {
      if (this.addRows.length === 1) return;
      this.addRows.splice(index, 1);
    },

    async openAddDialog() {
      this.addForm = {
        departure_id: null
      };
      this.addRows = [this.newAddRow()];
      await this.loadAvailableDepartures();
      this.addDepartureSearch = "";
      this.showAddDialog = true;
    },

    initializeInlineEdits() {
      const drafts = {};
      this.reservationRows.forEach(row => {
        drafts[row.key] = this.inlineEdits[row.key] || { ...row };
      });
      this.inlineEdits = drafts;
    },

    cancelInlineEdit(row) {
      this.$set(this.inlineEdits, row.key, { ...row });
    },

    goToManifest(row) {
      if (!row || !row.tour_id || !row.departure_id) return;
      const { href } = this.$router.resolve({
        name: "Departure Manifest",
        params: {
          tour_id: String(row.tour_id),
          departure_id: String(row.departure_id)
        }
      });
      window.open(href, "_blank", "noopener,noreferrer");
    }
  }
};
